export function dispatchCleonNoAd(container, settings, reason, extra = {}) {
  const detail = {
    reason,
    containerId: container?.id || null,
    zoneId: settings?.zoneId || settings?.zoneid || null,
    ...extra,
  };

  window.dispatchEvent(
    new CustomEvent("cleon:noAd", {
      detail,
    })
  );

  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          type: "cleon:noAd",
          detail,
        },
        "*"
      );
    }
  } catch (error) {
    console.warn("cleon:noAd postMessage failed", error);
  }
}